import { render } from "./OfficeGallery.vue?vue&type=template&id=655d5752"
import script from "./OfficeGallery.vue?vue&type=script&lang=js"
export * from "./OfficeGallery.vue?vue&type=script&lang=js"

import "./OfficeGallery.vue?vue&type=style&index=0&id=655d5752&lang=scss"

import exportComponent from "/home/runner/work/pmanastacio/pmanastacio/apps/anastacio_site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__